window.addCookieOnCartCreation = () => {
  const fbpCookie = getCookie("_fbp") ? getCookie("_fbp") : "";
  const fbcCookie = getCookie("_fbc") ? getCookie("_fbc") : "";
  const shippingTimeCart = getCookie("shipping_time_cart") ? getCookie("shipping_time_cart") : "";
  const deliveryTimeCart = getCookie("delivery_time_cart") ? getCookie("delivery_time_cart") : "";

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        fbp: fbpCookie,
        fbc: fbcCookie,
        shipping: shippingTimeCart,
        delivery: deliveryTimeCart,
      }
    })
  }).then(response => response.json())
};

window.fetchShippingTimeCartProducts = () => {
  if (!document.querySelector('[data-shipping-time="shipping-info-content"]')) return;
  const shippingInfoArray = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => {
      const productId = element.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_id') || "";
      const shippingInfo = element.querySelector('[data-shipping-time="shipping-info-content"]')?.textContent.trim() || "";
      return productId && shippingInfo ? { [productId]: shippingInfo } : null;
    })
    .filter(item => item !== null);

  setCookie("shipping_time_cart", JSON.stringify(shippingInfoArray), 6);

  // Also fetch delivery times while we're here
  fetchDeliveryTimeCartProducts();

  addCookieOnCartCreation();

  const dates = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => element.querySelector('[data-shipping-time="shipping-info-content"]')?.textContent.trim())
    .filter(dateText => dateText)
    .map(dateText => new Date(dateText));

  const latestDate = dates.length ? new Date(Math.max(...dates)) : null;
  const shippingInfoElement = document.querySelector('[data-name="shipping-info-drawer"]');

  if (shippingInfoElement) {
    if (latestDate) {
      const currentDate = new Date();
      const timeDifference = latestDate - currentDate;
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      let shippingInfo = "";
      shippingInfoElement.classList.add("estimated-ship");
      const productQuantities = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
        .map(item => parseInt(item.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_stock')) || 0);

      if (daysDifference <= 2 && productQuantities.every(quantity => quantity >= 1)) {
        shippingInfo = "Estimated shipping: 1-2 business days";
        shippingInfoElement.classList.add("ready-to-ship");
      } else if (daysDifference >= -5 && daysDifference <= 14) {
        shippingInfo = "Estimated shipping: 1-2 weeks";
      } else if (daysDifference >= 15 && daysDifference <= 21) {
        shippingInfo = "Estimated shipping: 2-3 weeks";
      } else if (daysDifference >= 22 && daysDifference <= 28) {
        shippingInfo = "Estimated shipping: 3-4 weeks";
      } else if (daysDifference >= 29 && daysDifference <= 35) {
        shippingInfo = "Estimated shipping: 4-5 weeks";
      } else if (daysDifference >= 36 && daysDifference <= 42) {
        shippingInfo = "Estimated shipping: 5-6 weeks";
      } else if (daysDifference >= 43 && daysDifference <= 49) {
        shippingInfo = "Estimated shipping: 6-7 weeks";
      } else if (daysDifference >= 50 && daysDifference <= 365) {
        shippingInfo = "Estimated shipping: 7-8 weeks";
      } else {
        shippingInfo = `Estimated shipping: ${latestDate.toLocaleDateString()}`;
      }
      shippingInfoElement.textContent = shippingInfo;
    }
  }
};

window.fetchDeliveryTimeCartProducts = () => {
  if (!document.querySelector('[data-delivery-time="delivery-info-content"]')) return;

  const deliveryInfoArray = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => {
      const productId = element.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_id') || "";
      const deliveryInfo = element.querySelector('[data-delivery-time="delivery-info-content"]')?.textContent.trim() || "";
      return productId && deliveryInfo ? { [productId]: deliveryInfo } : null;
    })
    .filter(item => item !== null);

  setCookie("delivery_time_cart", JSON.stringify(deliveryInfoArray), 6);

  const deliveryDates = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => element.querySelector('[data-delivery-time="delivery-info-content"]')?.textContent.trim())
    .filter(dateText => dateText)
    .map(dateText => new Date(dateText));

  const latestDeliveryDate = deliveryDates.length ? new Date(Math.max(...deliveryDates)) : null;
  const deliveryInfoElement = document.querySelector('[data-name="delivery-info-drawer"]');

  if (deliveryInfoElement) {
    if (latestDeliveryDate) {
      const currentDate = new Date();
      const timeDifference = latestDeliveryDate - currentDate;
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      let deliveryInfo = "";
      deliveryInfoElement.classList.add("estimated-delivery");

      const productQuantities = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
        .map(item => parseInt(item.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_stock')) || 0);

      if (productQuantities.every(quantity => quantity >= 1)) {
        deliveryInfo = "Estimated delivery:" + " " + daysDifference + " business days";
        deliveryInfoElement.classList.add("ready-to-ship");
      } else if (daysDifference >= -5 && daysDifference <= 14) {
        deliveryInfo = "Estimated delivery: 1-2 weeks";
      } else if (daysDifference >= 15 && daysDifference <= 21) {
        deliveryInfo = "Estimated delivery: 2-3 weeks";
      } else if (daysDifference >= 22 && daysDifference <= 28) {
        deliveryInfo = "Estimated delivery: 3-4 weeks";
      } else if (daysDifference >= 29 && daysDifference <= 35) {
        deliveryInfo = "Estimated delivery: 4-5 weeks";
      } else if (daysDifference >= 36 && daysDifference <= 42) {
        deliveryInfo = "Estimated delivery: 5-6 weeks";
      } else if (daysDifference >= 43 && daysDifference <= 49) {
        deliveryInfo = "Estimated delivery: 6-7 weeks";
      } else if (daysDifference >= 50 && daysDifference <= 56) {
        deliveryInfo = "Estimated delivery: 7-8 weeks";
      } else if (daysDifference >= 57 && daysDifference <= 365) {
        deliveryInfo = "Estimated delivery: 8-10 weeks";
      } else {
        deliveryInfo = `Estimated delivery: ${latestDeliveryDate.toLocaleDateString()}`;
      }
      deliveryInfoElement.textContent = deliveryInfo;
    }
  }
};
